import { transport } from 'config/transport';

export function callApiDeleteDanhMucCTPV(id) {
    return transport.del(`/ctpv/danhmuc/${id}`);
}
